import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { appendToRmaApiUrl } from '@rma/generic/ng/util';
import { Observable } from 'rxjs';
import { AgencyActivationDetails, VerifyAgencyActivation } from '../domain/model/agency-activation.model';

@Injectable({
  providedIn: 'root',
})
export class AgencyActivationService {
  private readonly http = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);

  declineActivation(activationCode: string): Observable<void> {
    return this.http.post<void>(this.rmaApiUrl('AgencyProfile/DeclineActivation'), { activationCode });
  }

  verifyActivation(verifyRequest: VerifyAgencyActivation): Observable<string> {
    return this.http.post<string>(this.rmaApiUrl('AgencyProfile/VerifyActivation'), verifyRequest);
  }

  getActivationDetails(activationCode: string): Observable<AgencyActivationDetails> {
    return this.http.get<AgencyActivationDetails>(this.rmaApiUrl('AgencyProfile/GetActivationDetails'), {
      params: { activationCode },
    });
  }
}
